import $ from "jquery";

const filterCat = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    $(".filter-cat-title").on("click", function () {
      // Finds the ul element that matches the clicked filter-cat-title
      const filterList = $(this).next(".filter-list");

      // Hide or show ul
      filterList.slideToggle();
    });

    // Loop through all elements with the .filter-list class
    $(".filter-list").each(function () {
      const itemCount = $(this).children(".filter-list-item").length;

      // Showing or hiding li meer and inferior by number
      if (itemCount > 4) {
        $(this).children(".filter-list-item:gt(3)").hide();
        $(this).children('.filter-list-meer-btn[id="show-filter"]').show();
        $(this).children('.filter-list-meer-btn[id="hide-filter"]').hide();
      } else {
        $(this).children(".filter-list-meer-btn").hide();
      }
    });

    // Added click function to .custom-show-all-filters
    $(".custom-show-all-filters").on("click", function () {
      const filterList = $(this).closest(".filter-list");
      filterList.children(".filter-list-item").show();
      filterList.children('.filter-list-meer-btn[id="show-filter"]').hide();
      filterList.children('.filter-list-meer-btn[id="hide-filter"]').show();
    });

    // Added click function to .custom-hide-all-filters
    $(".custom-hide-all-filters").on("click", function () {
      const filterList = $(this).closest(".filter-list");
      filterList.children(".filter-list-item:gt(3)").hide();
      filterList.children('.filter-list-meer-btn[id="show-filter"]').show();
      filterList.children('.filter-list-meer-btn[id="hide-filter"]').hide();
    });
  };

  init();
};

try {
  filterCat();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
